/* ============================================================
 * Colar + Pingentes — bundle do carrinho
 * ------------------------------------------------------------
 * Mantém o vínculo visual e operacional entre um colar e seus
 * pingentes (line items separados, agrupados por _grupo_colar).
 *
 * Comportamentos:
 *  1. Remover o colar  → remove em cascata todos os pingentes do mesmo grupo.
 *  2. Remover pingente → remove apenas aquele line item.
 *  3. Botões +/- do colar ficam bloqueados via HTML disabled (já feito no Liquid).
 * ============================================================ */
(function () {
  'use strict';

  if (window.__colarPingenteBundleInit) return;
  window.__colarPingenteBundleInit = true;

  /* ───────── helpers ───────── */

  function getSectionsToRender() {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender();
    }
    /* Fallback: detecta sections comuns na página */
    var sections = [];
    if (document.getElementById('cart-icon-bubble')) sections.push({ id: 'cart-icon-bubble', selector: '#shopify-section-cart-icon-bubble' });
    if (document.getElementById('main-cart-items')) sections.push({ id: 'main-cart-items', selector: '#main-cart-items' });
    if (document.getElementById('cart-live-region-text')) sections.push({ id: 'cart-live-region-text', selector: '#shopify-section-cart-live-region-text' });
    if (document.getElementById('main-cart-footer')) sections.push({ id: 'main-cart-footer', selector: '#main-cart-footer' });
    var minicart = document.querySelector('cart-drawer') || document.getElementById('minicart-form');
    if (minicart) {
      var id = minicart.closest('[id^="shopify-section-"]');
      if (id) sections.push({ id: id.id.replace('shopify-section-', ''), selector: '#minicart-form' });
    }
    return sections;
  }

  function applySections(parsedState, sections) {
    if (!parsedState || !parsedState.sections) return;
    sections.forEach(function (section) {
      var target = document.getElementById(section.id);
      var html = parsedState.sections[section.id];
      if (!target || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var selector = section.selector || ('#' + section.id);
      var fresh = doc.querySelector(selector) || doc.querySelector('#' + section.id);
      if (fresh) {
        target.innerHTML = fresh.innerHTML;
      }
    });
  }

  function refreshHeaderCount(parsedState) {
    if (!parsedState || parsedState.item_count == null) return;
    document.querySelectorAll('.cart-count').forEach(function (el) {
      if (el.classList.contains('cart-count-drawer')) {
        el.innerHTML = '(' + parsedState.item_count + ')';
      } else {
        el.innerHTML = parsedState.item_count > 100 ? '~' : parsedState.item_count;
      }
    });
    var headerTotal = document.querySelector('header-total-price');
    if (headerTotal && typeof headerTotal.updateTotal === 'function') {
      headerTotal.updateTotal(parsedState);
    }
    var freeShipBar = document.querySelector('free-ship-progress-bar');
    if (freeShipBar && typeof freeShipBar.init === 'function') {
      freeShipBar.init(parsedState.items_subtotal_price);
    }
  }

  /**
   * Manda /cart/update.js zerando uma lista de keys.
   * @param {string[]} keys
   * @param {Function} [onDone]
   */
  function removeKeys(keys, onDone) {
    if (!keys || !keys.length) return;
    var sections = getSectionsToRender();
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });

    var body = JSON.stringify({
      updates: updates,
      sections: sections.map(function (s) { return s.id; }),
      sections_url: window.location.pathname
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (parsedState) {
        applySections(parsedState, sections);
        refreshHeaderCount(parsedState);
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (typeof onDone === 'function') onDone(null, parsedState);
      })
      .catch(function (err) {
        console.warn('[bundle] erro ao remover itens:', err);
        if (typeof onDone === 'function') onDone(err);
      });
  }

  /* ───────── 1. Cascade-remove do colar ─────────
   * Intercepta o clique no botão de remover do colar (mini-cart-remove-button
   * ou cart-remove-button) ANTES dos handlers do tema. Se o colar tem
   * data-grupo, manda update zerando todos os keys do grupo de uma vez.
   */
  function findColarTrigger(target) {
    var bundleEl = target.closest('[data-grupo][data-grupo-papel="colar"]');
    if (!bundleEl) return null;
    /* Só intercepta cliques dentro do botão de remover (não em qty / edit) */
    var removeBtn = target.closest('mini-cart-remove-button, cart-remove-button, .cart-remove, [data-cart-remove]');
    if (!removeBtn) return null;
    return { bundle: bundleEl, grupo: bundleEl.getAttribute('data-grupo') };
  }

  function collectBundleKeys(grupo) {
    var keys = [];
    document.querySelectorAll('[data-grupo="' + CSS.escape(grupo) + '"][data-key]').forEach(function (el) {
      var k = el.getAttribute('data-key');
      if (k && keys.indexOf(k) === -1) keys.push(k);
    });
    return keys;
  }

  document.addEventListener('click', function (e) {
    var hit = findColarTrigger(e.target);
    if (!hit) return;

    /* Bloqueia o handler nativo (que removeria só o colar) */
    e.preventDefault();
    e.stopImmediatePropagation();

    var keys = collectBundleKeys(hit.grupo);
    if (!keys.length) return;

    /* Feedback visual rápido */
    hit.bundle.style.opacity = '0.4';
    hit.bundle.style.pointerEvents = 'none';
    var detailsEl = document.querySelector('details.cart-pingentes[data-grupo="' + CSS.escape(hit.grupo) + '"]');
    if (detailsEl) {
      detailsEl.style.opacity = '0.4';
      detailsEl.style.pointerEvents = 'none';
    }
    var bundleRow = document.querySelector('tr.cart-bundle-pingentes-row[data-bundle-grupo="' + CSS.escape(hit.grupo) + '"]');
    if (bundleRow) {
      bundleRow.style.opacity = '0.4';
      bundleRow.style.pointerEvents = 'none';
    }

    removeKeys(keys);
  }, true /* capture = true: roda antes dos listeners do tema */);

  /* ───────── 2. Remoção individual de pingente ─────────
   * Custom element <pingente-remove-button data-key="..." data-grupo="...">
   * dispara remoção daquele line item via /cart/update.js, mantendo o resto
   * do bundle intacto.
   */
  if (!customElements.get('pingente-remove-button')) {
    customElements.define('pingente-remove-button', class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
      }
      onClick(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var key = this.getAttribute('data-key');
        if (!key) return;
        var row = this.closest('.cart-pingente-row');
        if (row) row.classList.add('is-removing');
        removeKeys([key]);
      }
    });
  }
})();
